// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"73496b99","100":"917b38d4","315":"54ac5566","502":"0312b3b2","745":"0a5e04bc","762":"fc7edb31"}[chunkId] + ".chunk.css";
};